import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { coral } from '../../constants/color';
import FeatureFlags from '../../constants/FeatureFlags';
import Animatable from '../../elements/Animatable';
import Image from '../../elements/Image';
import Touchable from '../../elements/Touchable/Touchable';

export const styles: any = StyleSheet.create({
  checkBoxWrapper: {
    paddingLeft: 0,
    alignItems: 'flex-start',
    marginRight: 5,
  },
  priceContainer: {
    alignItems: 'center',
  },
  currencyText: {
    fontSize: 13,
    lineHeight: 15,
    fontWeight: 'normal',
    marginRight: 2,
  },
  priceText: {
    fontSize: 15,
    lineHeight: 17,
    fontWeight: '500',
    color: coral,
  },
  hide: {
    display: 'none',
  },
});

export const S = {
  ContentCard: styled(Animatable.View)`
    padding: 15px;
    min-height: 100px;
    background-color: ${({ theme }) => theme.palette.white};
  `,
  MainContentOfCard: styled.View`
    flex-direction: row;
  `,
  SelectionField: styled.View`
    width: 30px;
    padding: 0;
  `,
  ImageField: styled.View`
    margin-right: 10px;
    border-radius: 3px;
    overflow: hidden;
    width: 80px;
    height: 80px;
    align-self: flex-start;
    /* without this zindex checkBox hitSlop not work */
    z-index: -10;
  `,
  ItemImage: styled(Image)`
    width: 65px;
    height: 65px;
    border-radius: 3px;
  `,
  CancelButton: styled(Touchable)`
    position: absolute;
    right: 0;
    top: 0;
    width: 25px;
    height: 25px;
    justify-content: flex-start;
    align-items: flex-end;
    z-index: 1;
  `,
  DetailField: styled.View`
    position: relative;
    flex: 3;
  `,
  DescriptionField: styled.View`
    max-width: 90%;
    margin-bottom: ${FeatureFlags.GROWTH_715_OVERSTOCK_CONTAINER
      ? '10px'
      : '0'};
  `,
  TitleField: styled.View`
    position: relative;
    margin-bottom: ${FeatureFlags.GROWTH_715_OVERSTOCK_CONTAINER ? '2px' : '0'};
  `,
  TitleText: styled.Text<{ disabled?: boolean }>`
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme, disabled }) =>
      disabled ? theme.palette.neutralGrey : theme.palette.warrior};
  `,
  SKUField: styled.View`
    flex-direction: row;
    margin-bottom: ${FeatureFlags.GROWTH_715_OVERSTOCK_CONTAINER
      ? '4px'
      : '7px'};
    margin-top: 5px;
    max-width: 90%;
  `,
  SKUText: styled.Text<{ disabled?: boolean }>`
    font-size: 13px;
    line-height: 20px;
    margin-right: 2px;
    color: ${({ theme, disabled }) =>
      disabled ? theme.palette.neutralGrey : theme.palette.neutralDark};
  `,
  PaymentField: styled.View`
    margin-top: 15px;
    flex-direction: row;
  `,
  PriceField: styled.View`
    margin-top: auto;
    margin-left: 0;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
  `,
  CounterField: styled.View<{ disabled?: boolean }>`
    flex: 3;
    align-items: flex-end;
    justify-content: flex-end;
    display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
  `,
  TooSlowText: styled.Text<{ visible?: boolean }>`
    color: ${({ theme }) => theme.palette.warrior};
    font-size: 12px;
    line-height: 17px;
    display: ${({ visible }) => (visible ? 'flex' : 'none')};
  `,
  ImageSoldWrapper: styled.View<{ visible?: boolean }>`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.warrior}33;
    z-index: 1;
    display: ${({ visible }) => (visible ? 'flex' : 'none')};
    flex-direction: column-reverse;
  `,
  ImageSoldText: styled.Text`
    background-color: ${({ theme }) => theme.palette.warrior}CC;
    color: ${({ theme }) => theme.palette.white};
    text-align: center;
    padding: 2px;
  `,
  MultipleDiscountHint: styled.View`
    padding-left: 0;
    width: 100%;
    flex-direction: row;
  `,
  MultipleDiscountHintTitle: styled.View`
    margin-right: 10px;
    align-self: flex-start;
  `,
  MultipleDiscountHintText: styled.Text<{ isDiscount: boolean }>`
    color: ${({ isDiscount, theme }) =>
      isDiscount ? theme.palette.peacock : theme.palette.neutralDark};
    font-size: 12px;
    flex: 1;
  `,
};
